<template>
	<CreationWizardStepWrapper>
		<template #header>
			<CreateAutomationHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="height-100 display-flex flex-wrap">
			<div class="flex-col-12">
				<div class="top-section">
					<h2 class="reg">Which app you want to trigger with?</h2>
					<!-- <h3 class="reg">Click an app to see available triggers and contexts</h3> -->
				</div>
				<div class="action-section pt-5 display-flex flex-wrap">
					<div class="flex-col-9">
						<v-text-field v-model="searchField" outlined placeholder="Search" hide-details />
					</div>
				</div>

				<ListSelector class="pt-4" :items="apps" @selectItem="selectApp" allow-keyboard-navigation>
					<template #item-content="{ item }">
						<AppRow :app="item" />
					</template>
				</ListSelector>
				<AppLoader v-show="loading" />
			</div>
			<div class="bottom-section flex-1 display-flex">
				<!-- <h3 class="reg opacity-0-5">
					Can't find what you're looking for? <a role="button" href="#" target="_blank">Request support for an app</a>
				</h3> -->
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import { FlowType, WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';

import props from './CreateAutomation.props';
import CreateAutomationHeader from './CreateAutomationHeader.vue';
import WizardStepMixin from '../WizardStepMixin';
import AppRow from '../common/AppRow.vue';
import ListSelector from '@/components/common/ListSelector/ListSelector.vue';
import { getAllActiveServicesList } from '@/store/modules/apps/getters';
import { isScheduledTriggerOn } from '@/store/modules/featureFlags/getters';
import { createAndSelectWorkflow } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import AppService from '@/utils/AppService';

export default {
	name: 'CreateAutomation',
	mixins: [WizardStepMixin],
	props,
	components: { CreateAutomationHeader, ListSelector, AppRow },
	methods: {
		...mapActionsShorthand({ createAndSelectWorkflow }),
		async selectApp(appId) {
			this.createNewAutomationFlow(appId);
		},
		async createNewAutomationFlow(appId) {
			this.loading = true;
			try {
				this.closeWizard();
				// This will auto redirect to the new created flow!
				await this.createAndSelectWorkflow({
					workflow: {
						workflow_title: '',
						flow_type: FlowType.Cloud,
						access_type: WorkflowAccessType.SharedUsersOnly,
						project: this.selectedProjectId,
						trigger_service: appId,
					},
				});
			} catch (err) {
				this.$toast.error('Error occurred while creating new flow');
				console.error(err);
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {},
	computed: {
		...mapGettersShorthand({ getAllActiveServicesList, isScheduledTriggerOn }),
		allApps() {
			return this.getAllActiveServicesList;
		},
		appsWithTriggers() {
			return this.allApps.filter((app) => app.has_triggers);
		},
		allowedApps() {
			if (this.isScheduledTriggerOn) {
				return this.appsWithTriggers;
			}
			return this.appsWithTriggers.filter((app) => !AppService.isSlugOfScheduledWebhook(app.service_slug));
		},
		apps() {
			return this.allowedApps.filter(
				(app) =>
					app.service_name.toLowerCase().includes(this.searchField.toLowerCase()) ||
					app.service_slug.toLowerCase().includes(this.searchField.toLowerCase())
			);
		},
	},
	data() {
		return { loading: false, searchField: '' };
	},
};
</script>

<style scoped lang="scss"></style>
